import * as t from './actionTypes';

export function toggleEditProjectDialog(project = null) {
    return {
        type: t.TOGGLE_CREATE_PROJECT_DIALOG,
        project
    };
}